export class Message{
  constructor(id, type, message, params, timeout){
    this.id = id;
    this.message = message;
    this.options = {
      [type]: true,
      params
    };
    this.timeout = timeout
  }
  clearTimeout(){
    clearTimeout(this.timeout);
  }
}

export default class Messages {
  //My list of messages;
  messages = [];
  //A list of subscription functions
  subs = [];
  subscribe(sub){
    this.subs.push(sub);
  }

  unSubscribe(sub){
    this.subs = this.subs.filter(s => s !== sub)
  }

  notify(){
    this.subs.forEach(sub => sub());
  }

  add(msg){
    this.messages.push(msg);
    this.notify();
  }

  replace(msg){
    this.messages = [
      ...this.messages.filter(m => m.id !== msg.id),
      msg
    ];
    this.notify();
  }

  remove(msg){
    this.messages = this.messages.filter(m => m.id !== msg.id);
    this.notify();
  }
}
